import React from 'react'

export default function About() {
    return (
        <div className='p-[2vw] relative flex items-center md:-mt-[5vw] mt-5'>
            <img src="/images/about.png" alt="" className='md:block hidden' />
            <img src="/images/about-mobile.png" alt="" className='md:hidden block' />
            <div className='absolute md:px-20 px-5 space-y-3 top-[22vw] overflow-x-hidden'>
                <h1 className='md:text-6xl text-5xl animate__fadeInLeft wow animate__animated'>about <br /> chinu ai</h1>
                <p className='text-gray-400   text-lg animate__fadeInLeft wow animate__animated animate__delay-1s'>Chinu AI is an advanced AI Agent designed to capture your brand’s voice, adapt to your <br /> audience, and stay ahead of trends. Powered by GANs and transformer-based NLP, it evolves <br />
                    with every interaction, streamlining and enhancing your social media strategy.</p>
                <a href="#" className='w-fit'>
                    <img src="/images/try.png" alt="" className='md:w-[15vw] w-[45vw] animate__fadeInLeft wow animate__animated animate__delay-2s' />
                </a>
            </div>
        </div>
    )
}
